<template>
  <v-timeline-item color="primary" icon="add" small>
    <v-layout pt-3>
      <v-flex xs2>
        <strong>{{ contract.created }}</strong>
      </v-flex>
      <v-flex>
        <strong>Creación del contrato</strong>
        <template v-if="isTransfer">
          <div v-if="contract.clubLpfDestino"><u>Club LPF destino</u>: {{ contract.clubLpfDestino.nombre || '-' }}</div>
          <div v-else><u>{{ clubToLabel }}</u>: {{ contract.clubTo || '-' }}</div>
          <div class="text-formatted" v-if="isTransferLoaned">
            <span>¿<u>{{ contract.club.nombre }} tiene conceptos a su cargo</u>?</span>: {{ contract.hasConcepts ? ' sí' : ' no' }}</div>
        </template>
        <template v-if="contract.comment">
          <div><u>Comentarios</u>: {{ contract.comment }}</div>
        </template>
      </v-flex>
    </v-layout>
  </v-timeline-item>
</template>

<script>
const TRANSFER = 'Cesión'
const TRANSFER_LOANED = 'cedido'

export default {
  props: {
    contract: Object
  },

  computed: {
    isTransfer () {
      return (this.contract.contractType.includes(TRANSFER))
    },
    isTransferLoaned () {
      return this.contract.contractType.includes(TRANSFER_LOANED)
    },
    clubToLabel () {
      return this.isTransferLoaned ? 'Club destino' : 'Club de origen'
    }
  }
}
</script>
